import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPickup } from '../../modules/restaurant/types/Pickup';

const emptyPickup: IPickup = {
  _id: '',
  branch: {
    _id: '',
    title: '',
    address: '',
    delivery_available: false,
    location: {
      lon: 0,
      lat: 0,
    },
  },
};

let initialState: IPickup = emptyPickup;

try {
  const stored = localStorage.getItem('pickup');
  if (stored) initialState = JSON.parse(stored);
} catch {
  localStorage.removeItem('pickup');
}

export const SavePickupSlice = createSlice({
  name: 'savePickup',
  initialState,
  reducers: {
    savePickup: (_state, action: PayloadAction<IPickup>) => {
      localStorage.setItem('pickup', JSON.stringify(action.payload));
      return action.payload;
    },

    removePickup: () => {
      localStorage.removeItem('pickup');
      return emptyPickup;
    },

    setPickupOn: (state, action: PayloadAction<string | null>) => {
      const next = { ...state, pickupOn: action.payload };
      localStorage.setItem('pickup', JSON.stringify(next));
      return next;
    },
  },
});

export const { savePickup, removePickup, setPickupOn } = SavePickupSlice.actions;
export default SavePickupSlice.reducer;
